import {StatusPageVisibilityLevel} from "@/lib/types/statuspages.ts";
import {SharedStatusPageFormData} from "@/pages/statuspages/shared/StatusPage.types.ts";
import {CreateStatusPageChecksFormValues} from "@/pages/statuspages/statuspages-create/CreateStatusPageForm.types.ts";
import {StatusPageDesignTabDefaultValues} from "@/pages/statuspages/tabs/design/StatusPageDesignTab.form.ts";
import {StatusPageGeneralDefaultValues} from "@/pages/statuspages/tabs/general/StatusPageGeneralTab.form.ts";
import {SubscribersSettingsFormDefaultValues} from "@/pages/statuspages/tabs/subscribers/components/SubscribersSettingsForm/SubscribersSettingsForm.form.ts";

export const statusPageFormDataProcessing = (
  formData: SharedStatusPageFormData & Partial<CreateStatusPageChecksFormValues>
) => {
  const {password_protection_enabled, ...rest} = formData;
  return {
    ...rest,
    logo: typeof formData.logo === "string" ? undefined : formData.logo?.length ? formData.logo[0] : null,
    favicon: typeof formData.favicon === "string" ? undefined : formData.favicon?.length ? formData.favicon[0] : null,
    email_logo:
      typeof formData.email_logo === "string" ? undefined : formData.email_logo?.length ? formData.email_logo[0] : null,
    ...(password_protection_enabled === false && {auth_username: "", auth_password: ""}),
    initial_services:
      formData.initial_services &&
      [StatusPageVisibilityLevel.EXTERNAL_USERS, StatusPageVisibilityLevel.UPTIME_USERS].includes(
        formData.visibility_level
      )
        ? formData.initial_services
        : undefined,
  };
};

export const SharedStatusPageFormDefaultValues: SharedStatusPageFormData = {
  ...StatusPageGeneralDefaultValues,
  ...StatusPageDesignTabDefaultValues,
  ...SubscribersSettingsFormDefaultValues,
};
